import { createSelector } from '@saucelabs/sl-util-redux';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import { getTimeRangeFromInterval } from './../../util';

export const testHistory = (store) => store.apps.analytics.testHistory;
export const filters = (store) => store.apps.analytics.filters;
export const owners = (store) => store.apps.analytics.owners;
export const generalReducer = (store) => store.apps.analytics.generalReducer;
export const testHistoryViews = (store) => store.apps.analytics.testHistoryViews;

export const filtersSelector = createSelector({
  filtersState: filters,
})(({ filtersState }) => ({
  filters: filtersState.get('filters'),
  selectedDateFilter: filtersState.get('selectedDateFilter'),
}));

export const historySelector = createSelector({
  testHistoryState: testHistory,
  filtersState: filtersSelector,
  generalState: generalReducer,
  historyView: testHistoryViews,
  user: (store) => store.user,
  router: (store) => store.router,
  ownersState: owners,
})(({
  testHistoryState,
  filtersState,
  generalState,
  historyView,
  user,
  ownersState,
}) => ({
  ...filtersState,
  user,
  loading: generalState.get('loading'),
  loadingScatterplot: historyView.get('loadingScatterplot'),
  loadingTests: historyView.get('loadingTests'),
  loadingTestsError: generalState.getIn(['errors', 'getTests']),
  fadeMetrics: historyView.get('fadeMetrics'),
  errors: generalState.get('errors'),
  testSearchValue: testHistoryState.get('testSearchValue'),
  testNames: testHistoryState.get('testNames'),
  metrics: testHistoryState.get('metrics'),
  tests: testHistoryState.get('tests'),
  selectedTests: testHistoryState.get('selectedTests'),
  testsInGroup: testHistoryState.get('testsInGroup'),
  isTestSearchLoading: historyView.get('isTestSearchLoading'),
  loadingOwners: ownersState.get('loading'),
}));

export const testHistoryParamsSelector = (store, payload) => {
  const { analytics } = store.apps;

  return {
    ...getFilterParamsAdapter(analytics.filters.get('filters')),
    ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
    ...payload,
    from: 0,
  };
};

export const testsInGroupParamsSelector = (store, payload) => {
  const { analytics } = store.apps;
  const { status, duration_range: range, datetime } = payload;
  const interval = analytics.testHistory.get('histogramInterval');
  const { start, end } = getTimeRangeFromInterval(interval, datetime);

  return {
    ...getFilterParamsAdapter(analytics.filters.get('filters')),
    size: 50,
    from: 0,
    start,
    end,
    status,
    duration_from: range.from,
    duration_to: range.to,
  };
};
